var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1Bl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 307,
    viewBox: "0 0 449 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0596 155.44L128.148 83.3633L145.039 308.36L368.792 337.403L292.703 409.479L68.9497 380.437L52.0596 155.44Z",
    fill: "#D9166F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.6689 112.61L75.2734 0.886719L101.448 349.646L448.289 394.667L330.347 506.39L-16.494 461.369L-42.6689 112.61Z",
    fill: "url(#paint0_radial_16581_553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16581_553",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.323 328.934) rotate(136.551) scale(165.159 332.17)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1Bl);
export default __webpack_public_path__ + "static/media/shape1BL.08d4e466c890fda1a41abb67fc8e4c41.svg";
export { ForwardRef as ReactComponent };